import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { MobileTabsValues } from '../types';
import { TabsW, Tab } from './styled';

const TABS: { value: MobileTabsValues; labelKey: string }[] = [
  { value: MobileTabsValues.LATEST_UPDATES, labelKey: 'we.mobileTabs.latestUpdates' },
  { value: MobileTabsValues.OUR_VISION, labelKey: 'we.mobileTabs.ourVision' },
  { value: MobileTabsValues.COMPANY_INFO, labelKey: 'we.mobileTabs.companyInfo' },
  { value: MobileTabsValues.OUR_KPI_TARGET, labelKey: 'we.mobileTabs.ourKpiTarget' },
  { value: MobileTabsValues.OUR_TEAM, labelKey: 'we.mobileTabs.ourTeam' },
  { value: MobileTabsValues.MY_SCHEDULE, labelKey: 'we.mobileTabs.mySchedule' },
  { value: MobileTabsValues.MY_TASK, labelKey: 'we.mobileTabs.myTask' },
  { value: MobileTabsValues.MY_PINNED_POSTS, labelKey: 'we.mobileTabs.myPinnedPosts' },
  { value: MobileTabsValues.MY_QUICK_LINKS, labelKey: 'we.mobileTabs.myQuickLinks' },
];

type MobileTabsProps = {
  activeTab: MobileTabsValues;
  onChangeActiveTab: (tab: MobileTabsValues) => void;
};

export const MobileTabs = ({ onChangeActiveTab, activeTab }: MobileTabsProps) => {
  const { t } = useTranslation();
  const tabRefs = useRef<Partial<Record<MobileTabsValues, HTMLDivElement | null>>>({});

  useEffect(() => {
    tabRefs.current[activeTab]?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  }, [activeTab]);

  return (
    <TabsW>
      {TABS.map(({ value, labelKey }) => (
        <Tab
          key={value}
          ref={(el) => {
            tabRefs.current[value] = el;
          }}
          onClick={() => onChangeActiveTab(value)}
          className={activeTab === value ? 'active' : ''}
        >
          {t(labelKey)}
        </Tab>
      ))}
    </TabsW>
  );
};
